import { Stepper, Step, StepLabel, StepConnector, withStyles, makeStyles, useMediaQuery } from '@material-ui/core'
import theme from '../common/theme'
import clsx from 'clsx'
import { useTranslation } from 'next-i18next'

const useStepperStyle = makeStyles(theme => ({
  stepText: {
    fontSize: 20,
    fontWeight: 400,
    [theme.breakpoints.down('xs')]: {
      fontSize: 14,
    },
  },
  stepTextActive: {
    color: '#404041',
  }
}))

const useTrackingStepsIconStyles = makeStyles(theme => ({
  root: props => ({
    backgroundColor: '#EDEDED',
    zIndex: 1,
    color: '#ffffff',
    width: props.stepIconSize,
    height: props.stepIconSize,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
  }),
  active: {
    backgroundColor: '#C9F1FF !important',
  },
  completed: {
    backgroundColor: '#C9F1FF !important',
  },
}))

const TrackingStepsIcon = ({ active, completed, icon }) => {
  
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const stepIconSize = isMobile ? 60:80
  const classes = useTrackingStepsIconStyles({ stepIconSize: stepIconSize })

  const icons = {
    1: 'tracking-step-1.png',
    2: 'tracking-step-2.png',
    3: 'tracking-step-3.png',
    4: 'tracking-step-4.png',
  }

  const inactiveIcons = {
    1: 'tracking-step-1-grey.png',
    2: 'tracking-step-2-grey.png',
    3: 'tracking-step-3-grey.png',
    4: 'tracking-step-4-grey.png',
  }

  const renderIcon = (filename) => (
    <img src={`/static/img/tracking/${filename}`} alt="" style={{ width: stepIconSize-10, height: stepIconSize-10 }} />
  )

  return (
    <div
      className={
        clsx(classes.root, { [classes.active]: active, [classes.completed]: completed, })
      }
    >
      {
        (active || completed) ? (
          renderIcon(icons[String(icon)])
        ):(
          renderIcon(inactiveIcons[String(icon)])
        )
      }
    </div>
  )
}

const Steps = ({ activeStep }) => {

  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const classes = useStepperStyle()
  const stepIconSize = isMobile ? 60:80

  const { t } = useTranslation('tracking')

  const TrackingStepsConnector = withStyles({
    alternativeLabel: {
      top: stepIconSize/2,
      left: `calc(-50% + ${isMobile ? 0 : stepIconSize/2 + 15}px)`,
      right: `calc(50% + ${isMobile ? 0 : stepIconSize/2 + 15}px)`,
    },
    active: {
      '& $line': {
        backgroundColor: theme.palette.primary.main
      },
    },
    completed: {
      '& $line': {
        backgroundColor: theme.palette.primary.main
      },
    },
    line: {
      height: 3,
      border: 0,
      backgroundColor: '#E0E0E0',
      borderRadius: 1,
    },
  })(StepConnector)

  const steps = [
    t('status-pending'),
    t('status-prepare-to-ship'),
    t('status-shipping'),
    t('status-completed'),
  ]

  return (
    <div style={{ width: '100%' }}>
      <Stepper alternativeLabel activeStep={activeStep} connector={<TrackingStepsConnector />}>
        {
          steps.map((label) => (
            <Step key={label}>
              <StepLabel StepIconComponent={TrackingStepsIcon}><span className={clsx(classes.stepText)}>{label}</span></StepLabel>
            </Step>
          ))
        }
      </Stepper>
    </div>
  )
}

export default Steps